import React from 'react'


export const IonIcon = ({ name, ...props }) => {
  return <ion-icon {...props} style={{ pointerEvents: 'none' }} name={name}></ion-icon>
}
